import { render, staticRenderFns } from "./BinomialEditResults.vue?vue&type=template&id=29f95f98&"
import script from "./BinomialEditResults.vue?vue&type=script&lang=js&"
export * from "./BinomialEditResults.vue?vue&type=script&lang=js&"
import style0 from "./BinomialEditResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports